import React from 'react';
import {Button} from '@material-ui/core';
import {Server, ApiPaths} from '../../../../utils/Server';
import swal from 'sweetalert';
import { STATE_KEYS } from '../../../../assets/constants';
import Images from '../../../../assets/images/';

class EnactQuiz extends React.Component {

    constructor(props) {
        super(props);
        this.state = {isLoading: false, showCamera: false};
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();
        this.streamRef = null;
    }

    componentWillUnmount() {
        this.stopCamera();
    }

    startCamera = async (questionId) => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } },
                audio: false
            });
            this.streamRef = stream;
            this.setState({ showCamera: true }, () => {
                if (this.videoRef.current) {
                    this.videoRef.current.srcObject = stream;
                }
            });
        } catch (err) {
            if (err.name === 'NotAllowedError') {
                alert('Camera permission denied. Please allow camera access in your browser settings.');
            } else if (err.name === 'NotFoundError') {
                alert('No camera found on this device.');
            } else {
                alert('Unable to access camera. Please try using "Choose from Gallery" instead.');
            }
        }
    }

    stopCamera = () => {
        if (this.streamRef) {
            this.streamRef.getTracks().forEach(track => track.stop());
            this.streamRef = null;
        }
        this.setState({ showCamera: false });
    }

    capturePhoto = (questionId) => {
        const video = this.videoRef.current;
        const canvas = this.canvasRef.current;
        if (!video || !canvas) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0);

        canvas.toBlob((blob) => {
            if (blob) {
                const file = new File([blob], 'camera_photo.jpg', { type: 'image/jpeg' });
                this.stopCamera();
                this.uploadFile(file, questionId);
            }
        }, 'image/jpeg', 0.85);
    }

    uploadFile = (file, questionId) => {
        var formData = new FormData();
        formData.append('filename', file.name);
        formData.append('file', file);

        const apiheaders = {
            'Content-Type': 'multipart/form-data',
        };

        this.setState({isLoading: true}, async () => {
            await Server.post(ApiPaths.UPLOAD_FILE, formData, {
                headers: apiheaders
              })
                .then(response => {
                    const { data } = response;
                    if(data.statusCode === 200) {
                        this.handleQuestionAnswer(questionId, data.data);
                    } else {
                        alert('File not uploaded, Please try again');
                    }
                })
                .catch(err => {
                    alert('File not uploaded, Please try again');
                });

                this.setState({isLoading: false});
        });
    }

    handleImageUpload = (e, question) => {
        if (!e.target.files || !e.target.files[0]) return;
        this.uploadFile(e.target.files[0], question);
    }

    // Handle answer
    handleQuestionAnswer = (question, answer) => {

        var {userAnswers} = this.props;
        var alreadyExistsIndex = userAnswers.findIndex(x => x.question === question);

        //  remove answer if alreay exists
        if(alreadyExistsIndex >= 0 || answer === '') {
            userAnswers.splice(alreadyExistsIndex, 1);
        }

        // Add push amswer
        if(answer !== '') {
            userAnswers.push({question: question, answer: answer});
        }

        //  Add new answer for question
        this.props.handleSetState(STATE_KEYS.ANSWERS, userAnswers);

        // console.log("User answers", userAnswers)
    }

    // Remove image
    handleRemoveImage = (question) => {
        swal({
            title: "Are you sure?",
            text: "To remove this image to upload another one?",
            buttons: ["Cancel", "Remove"],
        })
        .then((willRemove) => {
            if (willRemove) {
                var {userAnswers} = this.props;
                var alreadyExistsIndex = userAnswers.findIndex(x => x.question === question);

                // remove answer if alreay exists
                if(alreadyExistsIndex >= 0) {
                    userAnswers.splice(alreadyExistsIndex, 1);
                }

                // Add new answer for question
                this.props.handleSetState(STATE_KEYS.ANSWERS, userAnswers);
                // console.log("User answers after remove", userAnswers)
            }
        });
    }

    renderCameraView = (questionId) => {
        return (
            <div className="text-center">
                <video
                    ref={this.videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{ width: '100%', maxWidth: 400, borderRadius: 8, border: '2px solid #007bff' }}
                />
                <canvas ref={this.canvasRef} style={{ display: 'none' }} />
                <div className="mt-3">
                    <button
                        className="btn btn-success py-2 px-4 mr-2"
                        onClick={() => this.capturePhoto(questionId)}
                    >
                        <i className="fa fa-camera mr-2"></i>{'Capture'}
                    </button>
                    <button
                        className="btn btn-secondary py-2 px-4"
                        onClick={this.stopCamera}
                    >
                        <i className="fa fa-times mr-2"></i>{'Cancel'}
                    </button>
                </div>
            </div>
        );
    }

    renderTestView = () => {
        const {showQuestion, userAnswers, questions} = this.props;
        const {isLoading, showCamera} = this.state;
        const question = questions[showQuestion];
        var alreadyExistsIndex = userAnswers.findIndex(x => x.question === question.id);
        var answerSaved = '';

        if(alreadyExistsIndex >= 0) {
            answerSaved = userAnswers[alreadyExistsIndex].answer;
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-left">
                            <img src={question.taskDesc} className="img-fluid" loading="lazy" alt="" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12">
                        {/* Image upload loader */}
                        {isLoading ?
                            <div className="form-group">
                                <img src={Images.loader} height={44} alt="Loading . . ."/><br/>
                                <button type="button" className="mt-3 btn btn-primary btn-sm">{"Uploading Image . . ."}</button>
                            </div>
                        : showCamera ?
                            <div className="form-group">
                                {this.renderCameraView(question.id)}
                            </div>
                        :
                            <div className="form-group">
                                {/* Show before image upload */}
                                {(answerSaved === '') && (
                                    <div>
                                        <label htmlFor={"enact_gallery_" + showQuestion} className="btn btn-success py-2 px-3 mb-2 mr-2">
                                            <i className="fa fa-image mr-2"></i>{'Choose from Gallery'}
                                        </label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            name={"enact_gallery_" + showQuestion}
                                            id={"enact_gallery_" + showQuestion}
                                            onChange={(e) => this.handleImageUpload(e, question.id)}
                                            style={{display: 'none'}}
                                        />
                                        <button
                                            className="btn btn-primary py-2 px-3 mb-2"
                                            onClick={() => this.startCamera(question.id)}
                                        >
                                            <i className="fa fa-camera mr-2"></i>{'Take Photo'}
                                        </button>
                                        <br/>
                                        <span className="small_text">{'Choose an image from your gallery or take a new photo with your camera.'}</span>
                                    </div>
                                )}

                                {/* Show after image upload */}
                                {(answerSaved && answerSaved !== '') &&
                                    <div>
                                        <div className="row">
                                            <div className="col text-left">
                                                <h6>
                                                    <i className="fa fa-check-circle text-success mr-1" style={{fontSize:20}}></i>
                                                    {'Image Uploaded'}
                                                </h6>
                                            </div>
                                            <div className="col text-right">
                                                <button className="btn btn-sm btn-danger" onClick={(e) => this.handleRemoveImage(question.id)}>{'Remove Image'}</button>
                                            </div>
                                        </div>

                                        {/* Show uploaded image preview */}
                                        <img src={answerSaved} className="previewImage img-thumbnail mt-3" alt="" />
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>

                {/* Show next or submit button based on question */}
                <div className="align-center mt-5">
                    {(questions.length - 1) !== showQuestion ?
                        <Button size={"large"} variant="contained" color="primary" onClick={() => this.props.handleNextButton()}>Next</Button>
                    :
                        <Button size={"large"} variant="contained" color="primary" onClick={() => this.props.handleTestSubmit()}>Submit</Button>
                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="text-center mb-4">Take a picture of yourself as same as in the picture given below and upload it</h5>
                    {this.renderTestView()}
                </div>
            </div>
        );
    }
}

export default EnactQuiz;
